import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@features/auth/contexts/AuthContext";

export function PrivateRoutes() {
  const { user } = useAuth();
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}

export function GuestRoutes() {
  const { user } = useAuth();
  return !user ? <Outlet /> : <Navigate to="/" replace />;
}
